<template>
  <div>
    <a-modal
      title="确认理事工作"
      v-model="isShow"
      ok-text="提交"
      centered
      :width="1200"
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      @ok="handleSubmit"
    >
      <div style="color: red">提示：每次修改后，点击“提交”按钮，才会保存修改信息！</div>
      <a-table
        :scroll="{ y: 250 }"
        :columns="itemColumns"
        :data-source="directorItems"
        :loading="loading"
        :pagination="false"
        row-key="id"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      >
        <div slot="director" slot-scope="director,record">
          <a-select
            v-model:value="record.director"
            style="width: 150px"
            mode="combobox"
            @change="(val) => handleSearch(val, record)"
          >
            <a-select-option
              v-for="director in userOptions"
              :key="director.emp_name"
              :value="director.emp_name"
            >
              {{ director.emp_name }}
            </a-select-option>
          </a-select>
        </div>
      </a-table>

      <div class="custom-table-operation-buttons" style="margin-top: 15px;">
        <a-button type="primary" @click="isShowNewNodeModal = true">新增服务节点</a-button>
      </div>

      <a-table
        :scroll="{ x: 'max-content', y: 350 }"
        :columns="nodeColumns"
        :data-source="nodes"
        :loading="loading"
        :pagination="false"
        :row-key="(record, index) => index"
      >
        <div slot="date" slot-scope="date,record">
          <a-range-picker
            :show-time="{ format: 'HH:mm' }"
            :placeholder="['开始时间', '结束时间']"
            format="YYYY-MM-DD HH:mm"
            style="width: 340px;"
            :value="record.date"
            @change="(val) => handleChangeDate(val, record)"
          />
          <div class="error-message">
            {{ record.error }}
          </div>
        </div>

        <div slot="remark" slot-scope="remark,record">
          <a-input
            style="width: 150px;"
            :max-length="20"
            v-model:value="record.remark"
            placeholder="请输入备注"
          />
        </div>

        <span slot="actions" slot-scope="text, record, index">
          <a-space>
            <a @click="deleteNode(index)" class="custom-delete">删除</a>
            <a @click="up(index)">上移</a>
            <a @click="down(index)">下移</a>
          </a-space>
        </span>
      </a-table>

      <new-node
        v-if="isShowNewNodeModal"
        :visible.sync="isShowNewNodeModal"
        @submit="submitNodes"
      />
    </a-modal>
  </div>
</template>
<script>
import { findOrderAuthorityOptions } from '@/api/user'
import { findConfirmDirectorWorkForm, confirmDirectorWork } from '@/api/order'
import calendarConverter from 'js-calendar-converter'
import { formatRangeBeginDateTime, formatRangeEndDateTime } from '@/utils/time'

export default {
  name: 'ConfirmDirectorWork',
  components: {
    NewNode: () => import('@/views/orders/tenant/operation_modal/NewOrderServiceNode.vue')
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: true
    },
    serviceOrderId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      submitting: false,
      order: {},
      userOptions: [],
      loadingUserOptions: false,
      directorOptions: [],
      defaultUser: {},
      directorItems: [],
      nodes: [],
      loading: false,
      selectedRowKeys: [],
      selectedRows: [],
      isShowNewNodeModal: false,
      nameRules: [
        { required: true, message: '请输入名称' },
        { max: 10, message: '名称不能超过10个字符' }
      ]
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    itemColumns() {
      return [
        {
          title: '理事项',
          dataIndex: 'name'
        },
        {
          title: '负责人',
          dataIndex: 'director',
          scopedSlots: { customRender: 'director' }
        }
      ]
    },
    nodeColumns() {
      return [
        {
          title: '服务节点',
          dataIndex: 'name',
          width: 100
        },
        {
          title: '日期',
          dataIndex: 'date',
          width: 380,
          scopedSlots: { customRender: 'date' }
        },
        {
          title: '农历',
          dataIndex: 'lunar',
          width: 150,
          scopedSlots: { customRender: 'lunar' }
        },
        {
          title: '星期',
          dataIndex: 'week',
          width: 150,
          scopedSlots: { customRender: 'week' }
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: 180,
          scopedSlots: { customRender: 'remark' }
        },
        {
          title: '操作',
          dataIndex: 'actions',
          scopedSlots: { customRender: 'actions' }
        }
      ]
    }
  },
  created() {
    this.fetchUserOptions()
    this.fetchFormData()
  },
  methods: {
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },

    handleSearch(value, record) {
      // 如果超过限制长度，自动截断
      if (value && value.length > 20) {
        this.$nextTick(() => {
          record.director = value.slice(0, 20)
        })
      }
    },

    fetchFormData() {
      this.loading = true
      findConfirmDirectorWorkForm(this.serviceOrderId).then((res) => {
        if (res.code === 0) {
          this.directorItems = res.data.items_info.data
          for (const directorItem of this.directorItems) {
            if (directorItem.is_exist) {
              this.selectedRowKeys.push(directorItem.id)
              this.selectedRows.push(directorItem)
            }
          }

          const nodes = res.data.nodes_info.data
          for (const node of nodes) {
            if (node.date && node.date.length > 0) {
              const beginAt = this.$moment(node.date[0], 'YYYY-MM-DD HH:mm')
              const endAt = this.$moment(node.date[1], 'YYYY-MM-DD HH:mm')
              node.date = [beginAt, endAt]
              const lunar1 = this.fetchLunarDate(beginAt)
              const lunar2 = this.fetchLunarDate(endAt)
              if (lunar1 === lunar2) {
                node.lunar = lunar1
              } else {
                node.lunar = lunar1 + '~' + lunar2
              }
              const week1 = this.fetchLunarWeek(beginAt)
              const week2 = this.fetchLunarWeek(endAt)
              if (week1 === week2) {
                node.week = week1
              } else {
                node.week = week1 + '~' + week2
              }
            }
            this.nodes.push(node)
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },

    handleChangeDate(value, record) {
      record.error = '请选择日期'
      record.date = value
      if (value && value.length > 0) {
        const lunar1 = this.fetchLunarDate(value[0])
        const lunar2 = this.fetchLunarDate(value[1])
        if (lunar1 === lunar2) {
          record.lunar = lunar1
        } else {
          record.lunar = lunar1 + '~' + lunar2
        }

        const week1 = this.fetchLunarWeek(value[0])
        const week2 = this.fetchLunarWeek(value[1])
        if (week1 === week2) {
          record.week = week1
        } else {
          record.week = week1 + '~' + week2
        }
        record.error = ''
      } else {
        record.lunar = ''
        record.week = ''
      }
      this.nodes = [...this.nodes]
    },

    calendarLunar(date) {
      if (!date) {
        return ''
      }
      return calendarConverter.solar2lunar(date.year(), date.month() + 1, date.date())
    },

    fetchLunarDate(date) {
      const lunar = this.calendarLunar(date)
      return lunar.gzYear + '年' + lunar.IMonthCn + lunar.IDayCn
    },

    fetchLunarWeek(date) {
      const lunar = this.calendarLunar(date)
      return lunar.ncWeek
    },

    deleteNode(index) {
      this.nodes.splice(index, 1)
    },

    up(index) {
      if (index === 0) {
        this.$warning({
          title: '已置顶无法上移',
          content: ''
        })
        return
      }

      const obj = this.nodes[index]
      const lastObj = this.nodes[index - 1]
      this.$set(this.nodes, index - 1, obj)
      this.$set(this.nodes, index, lastObj)
    },

    down(index) {
      if (index === this.nodes.length - 1) {
        this.$warning({
          title: '已置底无法下移',
          content: ''
        })
        return
      }
      const obj = this.nodes[index]
      const nextObj = this.nodes[index + 1]
      this.$set(this.nodes, index + 1, obj)
      this.$set(this.nodes, index, nextObj)
    },

    fetchUserOptions() {
      this.loadingUserOptions = true
      findOrderAuthorityOptions({ order_id: this.id }).then((res) => {
        if (res.code === 0) {
          this.userOptions = res.data
        }
        this.loadingUserOptions = false
      })
    },

    submitNodes(values) {
      for (const value of values) {
        this.nodes.push({
          id: value.id,
          name: value.name,
          date: [],
          lunar: undefined,
          week: undefined,
          remark: ''
        })
      }
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
      }

      const reqNodes = []
      let hasError = false
      for (const node of this.nodes) {
        this.handleChangeDate(node.date, node)
        if (node.error) {
          hasError = true
        } else {
          reqNodes.push({
            ...node,
            begin_at: formatRangeBeginDateTime(node.date),
            end_at: formatRangeEndDateTime(node.date)
          })
        }
      }
      if (hasError) {
        return
      }
      this.submitting = true
      const data = {
        director_items: this.selectedRows,
        nodes: reqNodes
      }
      confirmDirectorWork(this.serviceOrderId, data).then((res) => {
        if (res.code === 0) {
          // 关闭模态框
          this.isShow = false
          // 告知父组件已完成
          this.$emit('completed')
        }
        this.submitting = false
      })
    }
  }

}
</script>

<style lang="less" scoped>
.error-message {
  color: #ff4d4f;
  font-size: 12px;
  margin-top: 4px;
}
</style>

